import React, { useState } from 'react';

function PartnerForm({ partner, onSave, onCancel }) {
  const blank = {
    name:'', full_name:'', email:'', phone:'', cpf:'', cnpj:'',
    address:'', city:'', state:'', zip:'',
    bank_name:'', bank_agency:'', bank_account:'', bank_pix:'',
    default_commission:'', notes:'', consultants:[]
  };
  const [f, setF] = useState({ ...blank, ...(partner||{}), consultants: partner?.consultants || [] });
  const set = (k,v) => setF(p=>({...p,[k]:v}));

  // Gestão de consultores
  const [newConsName, setNewConsName] = useState('');
  const [newConsEmail, setNewConsEmail] = useState('');
  const addConsultant = () => {
    if (!newConsName.trim()) return;
    const c = { id: Date.now().toString(), name: newConsName.trim(), email: newConsEmail.trim() };
    set('consultants', [...(f.consultants||[]), c]);
    setNewConsName(''); setNewConsEmail('');
  };
  const removeConsultant = (id) => set('consultants', (f.consultants||[]).filter(c=>c.id!==id));
  const inp = "apple-input w-full px-3 py-2 text-sm";
  const label = (txt) => <label className="text-xs text-gray-500 font-medium mb-1 block">{txt}</label>;

  return <form onSubmit={e=>{e.preventDefault();onSave(f);}} className="space-y-4 max-h-[75vh] overflow-y-auto pr-1">
    {/* Identificação */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Identificação</p>
      <div className="space-y-2">
        <div><input required className={inp} placeholder="Nome fantasia / Apelido *" value={f.name} onChange={e=>set('name',e.target.value)} /></div>
        <div><input className={inp} placeholder="Nome completo / Razão social" value={f.full_name} onChange={e=>set('full_name',e.target.value)} /></div>
        <div className="grid grid-cols-2 gap-2">
          <div>{label('CPF')}<input className={inp} placeholder="000.000.000-00" value={f.cpf} onChange={e=>set('cpf',e.target.value)} /></div>
          <div>{label('CNPJ')}<input className={inp} placeholder="00.000.000/0001-00" value={f.cnpj} onChange={e=>set('cnpj',e.target.value)} /></div>
        </div>
      </div>
    </div>
    {/* Contato */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Contato</p>
      <div className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <input className={inp} placeholder="E-mail" type="email" value={f.email} onChange={e=>set('email',e.target.value)} />
          <input className={inp} placeholder="Telefone / WhatsApp" value={f.phone} onChange={e=>set('phone',e.target.value)} />
        </div>
      </div>
    </div>
    {/* Endereço */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Endereço</p>
      <div className="space-y-2">
        <input className={inp} placeholder="Rua, número, complemento" value={f.address} onChange={e=>set('address',e.target.value)} />
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1"><input className={inp} placeholder="CEP" value={f.zip} onChange={e=>set('zip',e.target.value)} /></div>
          <div className="col-span-1"><input className={inp} placeholder="Cidade" value={f.city} onChange={e=>set('city',e.target.value)} /></div>
          <div className="col-span-1"><input className={inp} placeholder="Estado" value={f.state} onChange={e=>set('state',e.target.value)} /></div>
        </div>
      </div>
    </div>
    {/* Dados Bancários */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Dados Bancários</p>
      <div className="space-y-2">
        <input className={inp} placeholder="Chave PIX" value={f.bank_pix} onChange={e=>set('bank_pix',e.target.value)} />
        <div className="grid grid-cols-3 gap-2">
          <input className={inp} placeholder="Banco" value={f.bank_name} onChange={e=>set('bank_name',e.target.value)} />
          <input className={inp} placeholder="Agência" value={f.bank_agency} onChange={e=>set('bank_agency',e.target.value)} />
          <input className={inp} placeholder="Conta" value={f.bank_account} onChange={e=>set('bank_account',e.target.value)} />
        </div>
      </div>
    </div>
    {/* Comissão */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Comissão</p>
      <div className="space-y-3">
        <div>
          <label className="text-xs text-gray-500 font-medium mb-1 block">% padrão do parceiro</label>
          <div className="flex items-center gap-3">
            <input className={inp} type="number" min="0" max="100" step="0.1" placeholder="Ex: 10" value={f.default_commission} onChange={e=>set('default_commission',e.target.value)} />
            <span className="text-sm text-gray-400 whitespace-nowrap">%</span>
          </div>
          <p className="text-xs text-gray-400 mt-1">Pré-preenchido ao vincular o parceiro a um lead (sem consultor selecionado)</p>
        </div>
        <div>
          <label className="text-xs text-gray-500 font-medium mb-1 block">% padrão dos consultores</label>
          <div className="flex items-center gap-3">
            <input className={inp} type="number" min="0" max="100" step="0.1" placeholder="Ex: 5" value={f.consultants_commission||''} onChange={e=>set('consultants_commission',e.target.value)} />
            <span className="text-sm text-gray-400 whitespace-nowrap">%</span>
          </div>
          <p className="text-xs text-gray-400 mt-1">Auto-preenchido quando qualquer consultor deste parceiro for selecionado</p>
        </div>
      </div>
    </div>
    {/* Observações */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">Observações</p>
      <textarea className={inp} rows={2} placeholder="Notas gerais sobre o parceiro" value={f.notes} onChange={e=>set('notes',e.target.value)} />
    </div>
    {/* Consultores / Sub-parceiros */}
    <div>
      <p className="text-xs font-bold text-gray-400 mb-2">👥 Consultores</p>
      <p className="text-xs text-gray-400 mb-3">Pessoas físicas dentro deste parceiro que trazem leads. Ao vincular este parceiro a um lead, você poderá selecionar o consultor específico.</p>
      {/* Lista existente */}
      {(f.consultants||[]).length > 0 && <div className="space-y-1.5 mb-3">
        {(f.consultants||[]).map(c => (
          <div key={c.id} className="flex items-center justify-between bg-purple-50 border border-purple-100 rounded-xl px-3 py-2">
            <div>
              <div className="text-sm font-medium text-purple-800">{c.name}</div>
              {c.email && <div className="text-xs text-purple-400">{c.email}</div>}
            </div>
            <button aria-label="Fechar" type="button" onClick={()=>removeConsultant(c.id)}
              className="text-red-400 hover:text-red-600 text-xs font-bold transition-colors px-1">✕</button>
          </div>
        ))}
      </div>}
      {/* Adicionar novo consultor */}
      <div className="bg-gray-50 rounded-xl p-3 space-y-2">
        <p className="t-caption-2 font-semibold text-gray-400">Adicionar consultor</p>
        <input className={inp} placeholder="Nome *" value={newConsName} onChange={e=>setNewConsName(e.target.value)}
          onKeyDown={e=>{ if(e.key==='Enter'){ e.preventDefault(); addConsultant(); } }} />
        <input className={inp} placeholder="E-mail (opcional)" value={newConsEmail} onChange={e=>setNewConsEmail(e.target.value)}
          onKeyDown={e=>{ if(e.key==='Enter'){ e.preventDefault(); addConsultant(); } }} />
        <button type="button" onClick={addConsultant}
          className="w-full py-1.5 bg-purple-600 hover:bg-purple-700 text-white text-xs font-semibold rounded-xl transition-colors">
          + Adicionar consultor
        </button>
      </div>
    </div>
    <div className="flex gap-2 pt-1 sticky bottom-0 bg-white pb-1">
      <button type="submit" className="flex-1 bg-blue-500 text-white rounded-full py-2 text-sm font-semibold hover:bg-blue-600">Salvar</button>
      <button type="button" onClick={onCancel} className="flex-1 bg-gray-100 text-gray-600 rounded-full py-2 text-sm font-semibold hover:bg-gray-200">Cancelar</button>
    </div>
  </form>;
}

// ─── PartnerDetail ────────────────────────────────────────

export { PartnerForm };
